export function generateErrorMessage(error) {
  // Raw Axios or other error describing the problem (technical) || Unknown failure
  let message = error.message || 'Something went wrong unexpectedly';

  if (error.response) {
    // default message for response error
    message = 'A temporary problem has caused your request to fail. Try again later.';
    const response = error.response;
    // error provided in response
    if (response.data && response.data.err) {
      message = response.data.err;
    } else if (response.data && response.data.error) {
      message = response.data.error;
    } else if (response.err || response.error) {
      message = response.err || response.error;
    }
    // Create message based on status number
    else if (typeof response.status === 'number' && response.status >= 400) {
      switch (response.status) {
        case 500: // Internal Server Error
          message = 'The server encountered an error processing the request. Try again later.';
          break;
        case 501: // Not Implemented
          message = 'The server does not know how to respond to that request.';
          break;
        case 502: // Bad Gateway
        case 503: // Service Unavailable
        case 504: // Gateway Timeout
          message = 'The server could not be reached or is not responding. Try again later.';
          break;
        case 401: // Unauthorized (not authenticated)
          message = 'You must be logged in to do that action.';
          break;
        case 403: // Forbidden (not authorized)
          message = 'Your permissions do not permit you to do that action.';
          break;
        case 404: // Not Found
          message = 'No data for that resource was found.';
          break;
        case 422: // Unprocessable Entity
          message = 'There are errors in your request, check your inputs and try again.';
          break;
        default:
          // generic 400 error
          message = 'A problem with your request has occurred. Try again later.';
          // generic 500 error
          if (response.status >= 500) {
            message = 'Something went wrong while talking with the server. Try again later.';
          }
      }
    }
  }
  // Error with the request (no server response)
  else if (error.request) {
    message = 'Something went wrong while talking to the server';
  }

  return message;
}
